"use client";

import { useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function WatchAndBuyCarousel({ data }: { data: any }) {
  const scrollRef = useRef<HTMLDivElement>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const [showArrows, setShowArrows] = useState(false);

  const cards: any[] = Array.isArray(data?.Cards?.[0]?.cardItem)
    ? data.Cards[0].cardItem
    : [];

  const videos = cards.map((card: any, idx: number) => ({
    id: card?.id ?? idx,
    title: card?.title || "",
    price: card?.price || "",
    oldPrice: card?.oldPrice || null,
    productUrl: card?.urlText || "#",
    videoUrl: card?.url || "",
    imageUrl: card?.image?.data?.attributes?.url || null,
  }));

  const scroll = (direction: "left" | "right") => {
    const container = scrollRef.current;
    if (!container) return;
    container.scrollBy({
      left: direction === "left" ? -320 : 320,
      behavior: "smooth",
    });
  };

  return (
    <section className="relative w-full py-10 bg-white flex flex-col items-center px-4">
      <h2 className="text-3xl md:text-4xl tracking-tight mb-8 text-center">
        {data?.title || "Shop By Look"}
      </h2>

      {/* WRAPPER */}
      <div
        ref={wrapperRef}
        className="relative w-full"
        onMouseEnter={() => setShowArrows(true)}
        onMouseLeave={() => setShowArrows(false)}
      >
        {/* LEFT ARROW */}
        <button
          onClick={() => scroll("left")}
          className={`absolute top-1/2 -translate-y-1/2 left-2
            h-10 w-10 rounded-full border bg-white shadow-xl
            flex items-center justify-center z-50 transition
            ${showArrows ? "opacity-100" : "opacity-0 pointer-events-none"}`}
        >
          <ChevronLeft className="w-6 h-6" />
        </button>

        {/* RIGHT ARROW */}
        <button
          onClick={() => scroll("right")}
          className={`absolute top-1/2 -translate-y-1/2 right-2
            h-10 w-10 rounded-full border bg-white shadow-xl
            flex items-center justify-center z-50 transition
            ${showArrows ? "opacity-100" : "opacity-0 pointer-events-none"}`}
        >
          <ChevronRight className="w-6 h-6" />
        </button>

        {/* CAROUSEL */}
        <div className="w-full overflow-hidden">
          <div
            ref={scrollRef}
            className="
              flex gap-5 overflow-x-auto scrollbar-hide scroll-smooth pb-4 
              snap-x snap-mandatory
            "
          >
    
            <div className="w-[120px] flex-none pointer-events-none"></div>

            {videos.map((item) => (
              <a
                key={item.id}
                href={item.productUrl}
                className="snap-start flex-none"
              >
                <article className="relative w-[250px] rounded-xl overflow-hidden transition">

                  {/* VIDEO */}
                  <div className="relative w-full aspect-[9/14] overflow-hidden">
                    <div className="w-full h-full rounded-xl overflow-hidden">
                      <video
                        src={item.videoUrl}
                        autoPlay
                        loop
                        muted
                        playsInline
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </div>

                  {/* LABEL */}
             <div className="absolute bottom-0 left-0 right-0">
           <div className="m-3 p-3 rounded-xl bg-black/40 border border-white/10 flex gap-3 backdrop-blur-sm">
          <div className="h-12 w-12 rounded-lg overflow-hidden border border-white/10">
      <img
        src={item.imageUrl}
        alt={item.title}
        className="w-full h-full object-cover"
      />
    </div>

    <div className="flex-1">
      <h3 className="text-xs sm:text-sm font-semibold line-clamp-2 text-white">
        {item.title}
      </h3>

      <div className="flex gap-2 items-baseline mt-1">
        <span className="text-sm font-bold text-white">{item.price}</span>
        {item.oldPrice && (
          <span className="text-[11px] text-gray-300 line-through">
            {item.oldPrice}
          </span>
        )}
      </div>
    </div>
  </div>
</div>
                </article>
              </a>
            ))}

            {/* RIGHT GAP */}
            <div className="w-6 flex-none"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
